import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

const WorkAddressFormElement = ({ name, control, label, type }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            variant="outlined"
            type={type}
            label={label}
            error={!!error}
            value={field.value ? field.value : ''}
            onChange={field.onChange}
            fullWidth
            sx={{
              marginBottom: 1,
              '& .MuiInputBase-root': {
                border: '1px solid #DCE4E8',
                borderRadius: '15px',
              },
            }}
            {...field}
          />
        );
      }}
    />
  );
};

export default WorkAddressFormElement;
